export default __webpack_public_path__ + "static/media/design-pine-logo.280a7d74.webp";